export default {
  "circulating-supply": () => import("/app/apps/explorer-plus/layouts/circulating-supply/CirculatingSupply.vue").then(m => m.default || m),
  common: () => import("/app/apps/explorer-plus/layouts/common.vue").then(m => m.default || m),
  content: () => import("/app/apps/explorer-plus/layouts/content/content.vue").then(m => m.default || m),
  default: () => import("/app/apps/explorer-plus/layouts/default.vue").then(m => m.default || m),
  featured: () => import("/app/apps/explorer-plus/layouts/featured.vue").then(m => m.default || m),
  home: () => import("/app/apps/explorer-plus/layouts/home.vue").then(m => m.default || m),
  "on-chain-analytics": () => import("/app/apps/explorer-plus/layouts/on-chain/analytics/Analytics.vue").then(m => m.default || m),
  scroll: () => import("/app/apps/explorer-plus/layouts/scroll.vue").then(m => m.default || m)
}